import React, { useRef, useState } from 'react'
import styles from './styles.module.css'
import Loader from '../../../components/Loader'
import MessageItem from '../MessageItem'
import { pack } from '../../../utils/pack'
import { createMessage } from '../../../actions/FAQ'
import { useDispatch } from 'react-redux'

const Index = ({ chatId, data, loading }) => {
    const dispatch = useDispatch()
    const fileRef = useRef(null)
    const taRef = useRef(null)
    const [text, setText] = useState('')
    const [files, setFiles] = useState([])
    const [replyTo, setReplyTo] = useState(null) // { id, from_user }

    const handleSend = () => {
        if (!text.trim() && !files.length) return
        dispatch(createMessage({ chat: chatId, parent: replyTo ? replyTo.id : 0, message: text }, files))
        setText('')
        setFiles([])
        setReplyTo(null)
        if (fileRef.current) fileRef.current.value = ''
    }

    const handleFileChange = e => {
        setFiles([...e.target.files])
    }

    const handleReply = msg => {
        setReplyTo({ id: msg.id, from_user: msg.from_user })
        taRef.current?.focus()
    }

    const renderTree = (nodes, depth = 0) => {
        if (!nodes || !nodes.length) return null
        return nodes.map(item => (
            <div key={item.id}>
                <MessageItem
                    item={{ ...item, chat: chatId }}
                    isDeLete={!item.columns?.length && item.parent !== 0}
                    isMine={item.is_new === 0}
                    onReply={handleReply}
                />
                {item.columns?.length > 0 && (
                    <div className={styles.nested}>
                        {renderTree(item.columns, depth + 1)}
                    </div>
                )}
            </div>
        ))
    }

    const fileNames = files.length ? files.map(f => f.name).join(', ') : null

    return (
        <div className={styles.thread}>
            {loading ? (
                <Loader />
            ) : (
                renderTree(pack(data, 0))
            )}

            <div className={styles.composer}>
                {replyTo && (
                    <div className={styles.replyHint}>
                        ↩ Ответ: {replyTo.from_user}
                        <button className={styles.replyCancel} onClick={() => setReplyTo(null)}>✕</button>
                    </div>
                )}
                <textarea
                    ref={taRef}
                    className={styles.composerTa}
                    placeholder="Написать сообщение…"
                    value={text}
                    onChange={e => setText(e.target.value)}
                />
                <div className={styles.composerRow}>
                    <button className={styles.btnFile} onClick={() => fileRef.current?.click()}>
                        Добавить файл
                    </button>
                    <input
                        ref={fileRef}
                        type="file"
                        multiple
                        hidden
                        onChange={handleFileChange}
                    />
                    <span className={`${styles.fileLabel}${fileNames ? ' ' + styles.has : ''}`}>
                        {fileNames ? `📎 ${fileNames}` : 'Нет файлов'}
                    </span>
                    <button className={styles.btnSend} onClick={handleSend}>
                        Отправить
                    </button>
                </div>
            </div>
        </div>
    )
}

export default Index
